/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:d28ba1ec-f4cf-4d7f-8ce4-c8ca2da216cd",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_gnhgkALys",
    "aws_user_pools_web_client_id": "2i71po1ougrrqhcvehtj55a5ng",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "airtable",
            "endpoint": "https://zppikpfmjk.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "stripe",
            "endpoint": "https://sd3m4iprxe.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
